
export const parkCategories = [
  'All',
  'Trails',
  'Playgrounds',
  'Sports Facilities',
  'Dog Parks',
  'Nature Preserves'
];

export const parkAmenityIcons: Record<string, string> = {
  'Restrooms': 'ri-building-4-line',
  'Parking': 'ri-parking-box-line',
  'ADA Accessible': 'ri-wheelchair-line',
  'Pet Friendly': 'ri-bear-smile-line',
  'Water Fountain': 'ri-drop-line',
  'Picnic Tables': 'ri-restaurant-line',
  'BBQ Grills': 'ri-fire-line',
  'Bike Rack': 'ri-riding-line',
  'Shade Structures': 'ri-umbrella-line',
  'Lighting': 'ri-flashlight-line',
  'Benches': 'ri-armchair-line',
  'Playground': 'ri-gamepad-line',
};

export const trails = [
  {
    id: 't1',
    name: 'Miners Ravine Trail',
    type: 'Trails',
    difficulty: 'Easy',
    length: '7.0 mi',
    surface: 'Paved',
    elevation: '120 ft',
    description: 'A scenic paved trail winding through oak woodlands and along Miners Ravine Creek. Perfect for walking, jogging, and cycling with multiple access points and creek crossings via wooden bridges.',
    image: 'https://public.readdy.ai/ai/img_res/8a539375ed227eab110f93e664bf7ee5.jpg',
    address: 'Miners Ravine Trail, Roseville, CA 95661',
    hours: 'Sunrise to Sunset',
    amenities: ['Restrooms', 'Parking', 'Bike Rack', 'Benches', 'Pet Friendly', 'Water Fountain'],
    rating: 4.8,
    reviews: 342,
    featured: true,
    coordinates: { lat: 38.7496, lng: -121.2640 }
  },
  {
    id: 't2',
    name: 'Dry Creek Parkway Trail',
    type: 'Trails',
    difficulty: 'Easy',
    length: '5.2 mi',
    surface: 'Paved',
    elevation: '85 ft',
    description: 'Popular multi-use trail connecting neighborhoods with parks along Dry Creek. Enjoy wildlife watching, native plant gardens, and peaceful creek-side scenery throughout the seasons.',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20paved%20parkway%20trail%20along%20a%20creek%20with%20native%20California%20grasses%20and%20wildflowers%2C%20families%20walking%20dogs%2C%20birds%20near%20water%2C%20natural%20landscape%20with%20oak%20trees%2C%20golden%20hour%20lighting&width=600&height=400&seq=park002&orientation=landscape',
    address: 'Dry Creek Parkway, Roseville, CA 95747',
    hours: 'Sunrise to Sunset',
    amenities: ['Parking', 'Benches', 'Pet Friendly', 'Water Fountain'],
    rating: 4.6,
    reviews: 218,
    featured: true,
    coordinates: { lat: 38.7712, lng: -121.3120 }
  },
  {
    id: 't3',
    name: 'Oak Ridge Trail',
    type: 'Trails',
    difficulty: 'Moderate',
    length: '3.8 mi',
    surface: 'Dirt/Gravel',
    elevation: '210 ft',
    description: 'A moderately challenging dirt trail through rolling oak-studded hills with panoramic views of the Sierra Nevada foothills. Great for trail running and mountain biking.',
    image: 'https://readdy.ai/api/search-image?query=Dirt%20hiking%20trail%20through%20rolling%20California%20hills%20with%20scattered%20oak%20trees%2C%20panoramic%20view%20of%20Sierra%20Nevada%20foothills%20in%20distance%2C%20trail%20runner%20on%20path%2C%20golden%20grass%2C%20clear%20blue%20sky%2C%20natural%20beauty&width=600&height=400&seq=park003&orientation=landscape',
    address: '9200 Oak Ridge Dr, Roseville, CA 95661',
    hours: 'Sunrise to Sunset',
    amenities: ['Parking', 'Pet Friendly', 'Benches'],
    rating: 4.5,
    reviews: 156,
    featured: false,
    coordinates: { lat: 38.7380, lng: -121.2750 }
  },
  {
    id: 't4',
    name: 'Linda Creek Trail',
    type: 'Trails',
    difficulty: 'Easy',
    length: '2.4 mi',
    surface: 'Paved',
    elevation: '45 ft',
    description: 'A gentle paved path following Linda Creek through residential neighborhoods. Ideal for families with strollers, casual walkers, and evening strolls with beautiful creek views.',
    image: 'https://readdy.ai/api/search-image?query=Gentle%20paved%20walking%20path%20along%20a%20small%20creek%20in%20suburban%20California%20neighborhood%2C%20families%20with%20strollers%20walking%2C%20mature%20trees%20providing%20shade%2C%20well-maintained%20landscaping%2C%20peaceful%20evening%20light&width=600&height=400&seq=park004&orientation=landscape',
    address: 'Linda Creek Trail, Roseville, CA 95678',
    hours: 'Sunrise to Sunset',
    amenities: ['Benches', 'Pet Friendly', 'ADA Accessible', 'Lighting'],
    rating: 4.4,
    reviews: 98,
    featured: false,
    coordinates: { lat: 38.7550, lng: -121.2900 }
  },
  {
    id: 't5',
    name: 'Cresta Trail Loop',
    type: 'Trails',
    difficulty: 'Moderate',
    length: '4.1 mi',
    surface: 'Mixed',
    elevation: '180 ft',
    description: 'A scenic loop trail combining paved and natural surfaces through Cresta Park and surrounding open space. Features seasonal wildflower displays and bird watching opportunities.',
    image: 'https://readdy.ai/api/search-image?query=Loop%20hiking%20trail%20through%20California%20open%20space%20with%20seasonal%20wildflowers%20in%20bloom%2C%20mixed%20paved%20and%20dirt%20surface%2C%20bird%20watchers%20with%20binoculars%2C%20rolling%20green%20hills%2C%20spring%20landscape&width=600&height=400&seq=park005&orientation=landscape',
    address: 'Cresta Dr, Roseville, CA 95747',
    hours: 'Sunrise to Sunset',
    amenities: ['Parking', 'Restrooms', 'Pet Friendly', 'Benches'],
    rating: 4.3,
    reviews: 87,
    featured: false,
    coordinates: { lat: 38.7800, lng: -121.3050 }
  }
];

export const playgrounds = [
  {
    id: 'p1',
    name: 'Maidu Park Playground',
    type: 'Playgrounds',
    ageRange: 'Ages 2-12',
    description: 'A massive adventure playground within the 152-acre Maidu Regional Park featuring climbing structures, swings, slides, sand play areas, and a separate toddler zone with soft rubber surfacing.',
    image: 'https://readdy.ai/api/search-image?query=Modern%20colorful%20playground%20with%20climbing%20structures%2C%20slides%2C%20swings%20in%20a%20large%20California%20park%2C%20children%20playing%2C%20rubber%20safety%20surfacing%2C%20shade%20structures%20overhead%2C%20green%20grass%20surrounding%20area%2C%20sunny%20day&width=600&height=400&seq=park006&orientation=landscape',
    address: '1550 Maidu Dr, Roseville, CA 95661',
    hours: '6:00 AM - 10:00 PM',
    amenities: ['Restrooms', 'Parking', 'ADA Accessible', 'Shade Structures', 'Picnic Tables', 'Water Fountain'],
    rating: 4.9,
    reviews: 412,
    featured: true,
    features: ['Climbing Wall', 'Zip Line', 'Toddler Zone', 'Sand Play', 'Swings', 'Slides'],
    coordinates: { lat: 38.7521, lng: -121.2640 }
  },
  {
    id: 'p2',
    name: 'Kaseberg Park Playground',
    type: 'Playgrounds',
    ageRange: 'Ages 2-10',
    description: 'A nature-themed playground with tree house structures, rope bridges, and interactive musical instruments. Surrounded by mature oak trees providing natural shade throughout the day.',
    image: 'https://readdy.ai/api/search-image?query=Nature%20themed%20playground%20with%20treehouse%20climbing%20structure%2C%20rope%20bridges%2C%20wooden%20play%20equipment%2C%20children%20playing%2C%20surrounded%20by%20mature%20oak%20trees%2C%20natural%20shade%2C%20bark%20chip%20ground%20cover%2C%20California%20park%20setting&width=600&height=400&seq=park007&orientation=landscape',
    address: '1000 Kaseberg Dr, Roseville, CA 95747',
    hours: '6:00 AM - 10:00 PM',
    amenities: ['Restrooms', 'Parking', 'Shade Structures', 'Picnic Tables', 'Water Fountain', 'Pet Friendly'],
    rating: 4.7,
    reviews: 287,
    featured: true,
    features: ['Tree House', 'Rope Bridge', 'Musical Instruments', 'Nature Play', 'Swings'],
    coordinates: { lat: 38.7750, lng: -121.3100 }
  },
  {
    id: 'p3',
    name: 'Mahany Park Playground',
    type: 'Playgrounds',
    ageRange: 'Ages 5-12',
    description: 'An adventure-style playground adjacent to the Mahany Community Center with modern equipment, a splash pad for summer cooling, and a basketball half-court for older kids.',
    image: 'https://readdy.ai/api/search-image?query=Modern%20adventure%20playground%20with%20splash%20pad%20water%20feature%2C%20colorful%20climbing%20equipment%2C%20children%20playing%20in%20water%20spray%2C%20community%20center%20building%20in%20background%2C%20summer%20day%2C%20California%20suburban%20park&width=600&height=400&seq=park008&orientation=landscape',
    address: '1545 Pleasant Grove Blvd, Roseville, CA 95747',
    hours: '6:00 AM - 10:00 PM',
    amenities: ['Restrooms', 'Parking', 'ADA Accessible', 'Water Fountain', 'Lighting', 'Bike Rack'],
    rating: 4.6,
    reviews: 198,
    featured: false,
    features: ['Splash Pad', 'Climbing Wall', 'Basketball Court', 'Slides', 'Monkey Bars'],
    coordinates: { lat: 38.7680, lng: -121.3200 }
  },
  {
    id: 'p4',
    name: 'Vernon Street Tot Lot',
    type: 'Playgrounds',
    ageRange: 'Ages 1-5',
    description: 'A charming toddler-focused play area in historic downtown Roseville with age-appropriate equipment, soft surfacing, and a fully fenced perimeter for safety.',
    image: 'https://readdy.ai/api/search-image?query=Small%20charming%20toddler%20playground%20with%20colorful%20low%20equipment%2C%20soft%20rubber%20surfacing%2C%20fenced%20area%2C%20toddlers%20playing%20with%20parents%20watching%2C%20downtown%20park%20setting%2C%20flowers%20and%20landscaping%2C%20safe%20play%20environment&width=600&height=400&seq=park009&orientation=landscape',
    address: '400 Vernon St, Roseville, CA 95678',
    hours: '7:00 AM - 9:00 PM',
    amenities: ['ADA Accessible', 'Benches', 'Shade Structures', 'Parking'],
    rating: 4.5,
    reviews: 134,
    featured: false,
    features: ['Fenced Area', 'Toddler Slides', 'Spring Riders', 'Sensory Play'],
    coordinates: { lat: 38.7524, lng: -121.2880 }
  },
  {
    id: 'p5',
    name: 'Woodbridge Park Playground',
    type: 'Playgrounds',
    ageRange: 'Ages 2-12',
    description: 'A recently renovated inclusive playground designed for children of all abilities. Features wheelchair-accessible equipment, sensory panels, and ground-level play elements.',
    image: 'https://readdy.ai/api/search-image?query=Inclusive%20accessible%20playground%20with%20wheelchair%20ramps%2C%20sensory%20play%20panels%2C%20ground%20level%20spinning%20equipment%2C%20children%20of%20different%20abilities%20playing%20together%2C%20modern%20colorful%20design%2C%20California%20park%2C%20accessible%20surfacing&width=600&height=400&seq=park010&orientation=landscape',
    address: '2100 Woodbridge Dr, Roseville, CA 95747',
    hours: '6:00 AM - 10:00 PM',
    amenities: ['Restrooms', 'Parking', 'ADA Accessible', 'Shade Structures', 'Picnic Tables', 'Water Fountain'],
    rating: 4.8,
    reviews: 176,
    featured: true,
    features: ['Wheelchair Accessible', 'Sensory Panels', 'Inclusive Swings', 'Ground-Level Play', 'Spinning Equipment'],
    coordinates: { lat: 38.7620, lng: -121.3150 }
  }
];

export const sportsFacilities = [
  {
    id: 's1',
    name: 'Roseville Sports Center',
    type: 'Sports Facilities',
    sports: ['Basketball', 'Volleyball', 'Indoor Soccer', 'Badminton'],
    description: 'Premier multi-sport indoor facility with regulation basketball courts, volleyball courts, indoor soccer fields, and a full schedule of adult and youth leagues year-round.',
    image: 'https://readdy.ai/api/search-image?query=Modern%20indoor%20sports%20facility%20with%20basketball%20courts%2C%20bright%20LED%20lighting%2C%20hardwood%20floors%2C%20players%20in%20action%2C%20scoreboard%2C%20spectator%20seating%2C%20professional%20athletic%20center%20interior&width=600&height=400&seq=park011&orientation=landscape',
    address: '1545 Pleasant Grove Blvd, Roseville, CA 95747',
    hours: 'Mon-Fri 6:00 AM - 10:00 PM, Sat-Sun 8:00 AM - 8:00 PM',
    amenities: ['Restrooms', 'Parking', 'ADA Accessible', 'Water Fountain', 'Lighting'],
    rating: 4.7,
    reviews: 256,
    featured: true,
    coordinates: { lat: 38.7680, lng: -121.3200 }
  },
  {
    id: 's2',
    name: 'Roseville Tennis Center',
    type: 'Sports Facilities',
    sports: ['Tennis', 'Pickleball'],
    description: '12 lighted hard courts with a pro shop, offering lessons for all skill levels, USTA leagues, tournaments, and drop-in pickleball sessions on dedicated courts.',
    image: 'https://readdy.ai/api/search-image?query=Professional%20tennis%20center%20with%20multiple%20hard%20courts%2C%20players%20playing%20doubles%20match%2C%20green%20courts%20with%20white%20lines%2C%20lighting%20poles%20for%20night%20play%2C%20pro%20shop%20building%2C%20California%20sunshine%2C%20well%20maintained%20facility&width=600&height=400&seq=park012&orientation=landscape',
    address: '1000 Kaseberg Dr, Roseville, CA 95747',
    hours: '7:00 AM - 10:00 PM Daily',
    amenities: ['Restrooms', 'Parking', 'Lighting', 'Water Fountain', 'Bike Rack'],
    rating: 4.6,
    reviews: 189,
    featured: true,
    coordinates: { lat: 38.7750, lng: -121.3100 }
  },
  {
    id: 's3',
    name: 'Maidu Regional Sports Fields',
    type: 'Sports Facilities',
    sports: ['Soccer', 'Baseball', 'Softball', 'Football'],
    description: 'Expansive sports complex with 4 baseball diamonds, 6 multi-use fields for soccer and football, batting cages, and a concession stand. Home to Roseville youth leagues.',
    image: 'https://readdy.ai/api/search-image?query=Large%20sports%20field%20complex%20with%20baseball%20diamonds%2C%20soccer%20fields%2C%20green%20grass%2C%20youth%20teams%20playing%2C%20bleacher%20seating%2C%20concession%20stand%20building%2C%20parking%20lot%2C%20California%20suburban%20sports%20park&width=600&height=400&seq=park013&orientation=landscape',
    address: '1550 Maidu Dr, Roseville, CA 95661',
    hours: 'Varies by Season',
    amenities: ['Restrooms', 'Parking', 'Lighting', 'Water Fountain', 'Picnic Tables'],
    rating: 4.5,
    reviews: 312,
    featured: false,
    coordinates: { lat: 38.7521, lng: -121.2640 }
  },
  {
    id: 's4',
    name: 'Roseville Aquatics Complex',
    type: 'Sports Facilities',
    sports: ['Swimming', 'Water Polo', 'Diving'],
    description: 'State-of-the-art aquatic facility with a 50-meter competition pool, recreation pool with water slides, lazy river, splash pad, and year-round swim programs.',
    image: 'https://readdy.ai/api/search-image?query=Modern%20aquatic%20center%20with%20Olympic%20competition%20swimming%20pool%2C%20water%20slides%2C%20lazy%20river%2C%20families%20enjoying%20water%20activities%2C%20lifeguard%20stations%2C%20blue%20sparkling%20water%2C%20sunny%20California%20day&width=600&height=400&seq=park014&orientation=landscape',
    address: '951 Oak Ridge Dr, Roseville, CA 95661',
    hours: 'Mon-Fri 5:30 AM - 9:00 PM, Sat-Sun 8:00 AM - 6:00 PM',
    amenities: ['Restrooms', 'Parking', 'ADA Accessible', 'Water Fountain', 'Shade Structures'],
    rating: 4.8,
    reviews: 478,
    featured: true,
    coordinates: { lat: 38.7380, lng: -121.2750 }
  },
  {
    id: 's5',
    name: 'Diamond Oaks Disc Golf Course',
    type: 'Sports Facilities',
    sports: ['Disc Golf'],
    description: 'An 18-hole disc golf course winding through oak-studded terrain with varying difficulty levels. Free to play with well-marked tee pads and baskets throughout.',
    image: 'https://readdy.ai/api/search-image?query=Disc%20golf%20course%20in%20California%20park%20with%20metal%20basket%20target%2C%20oak%20trees%2C%20player%20throwing%20disc%2C%20well%20maintained%20grass%20fairway%2C%20course%20signage%2C%20recreational%20outdoor%20activity%2C%20sunny%20day&width=600&height=400&seq=park015&orientation=landscape',
    address: '79 Clover Valley Rd, Roseville, CA 95678',
    hours: 'Sunrise to Sunset',
    amenities: ['Parking', 'Pet Friendly', 'Benches'],
    rating: 4.4,
    reviews: 143,
    featured: false,
    coordinates: { lat: 38.7400, lng: -121.2800 }
  },
  {
    id: 's6',
    name: 'Roseville Skate Park',
    type: 'Sports Facilities',
    sports: ['Skateboarding', 'BMX', 'Scooter'],
    description: 'A 15,000 sq ft concrete skate park with bowls, rails, ramps, and street-style features. Open to skateboarders, BMX riders, and scooter riders of all skill levels.',
    image: 'https://readdy.ai/api/search-image?query=Modern%20concrete%20skate%20park%20with%20bowls%2C%20rails%2C%20ramps%2C%20skateboarders%20performing%20tricks%2C%20BMX%20riders%2C%20well%20designed%20urban%20recreation%20facility%2C%20California%20park%20setting%2C%20youth%20recreation&width=600&height=400&seq=park016&orientation=landscape',
    address: '1000 Kaseberg Dr, Roseville, CA 95747',
    hours: 'Sunrise to Sunset',
    amenities: ['Parking', 'Water Fountain', 'Lighting', 'Benches'],
    rating: 4.5,
    reviews: 167,
    featured: false,
    coordinates: { lat: 38.7750, lng: -121.3100 }
  }
];

export const dogParks = [
  {
    id: 'd1',
    name: 'Marco Dog Park',
    type: 'Dog Parks',
    description: 'Roseville\'s premier off-leash dog park with separate areas for large and small dogs, agility equipment, water stations, and shaded seating for owners.',
    image: 'https://readdy.ai/api/search-image?query=Large%20off-leash%20dog%20park%20with%20dogs%20playing%2C%20separate%20fenced%20areas%20for%20large%20and%20small%20dogs%2C%20agility%20equipment%2C%20water%20stations%2C%20owners%20sitting%20on%20benches%2C%20green%20grass%2C%20California%20park&width=600&height=400&seq=park017&orientation=landscape',
    address: '1201 Cirby Way, Roseville, CA 95678',
    hours: 'Sunrise to Sunset',
    amenities: ['Parking', 'Water Fountain', 'Benches', 'Pet Friendly', 'Shade Structures'],
    rating: 4.6,
    reviews: 234,
    featured: true,
    features: ['Large Dog Area', 'Small Dog Area', 'Agility Equipment', 'Water Stations', 'Double-Gate Entry'],
    coordinates: { lat: 38.7500, lng: -121.2700 }
  },
  {
    id: 'd2',
    name: 'Cresta Dog Park',
    type: 'Dog Parks',
    description: 'A spacious off-leash area within Cresta Park featuring rolling terrain, shade trees, and a community atmosphere. Popular for morning and evening dog socialization.',
    image: 'https://readdy.ai/api/search-image?query=Spacious%20dog%20park%20with%20rolling%20grassy%20terrain%2C%20shade%20trees%2C%20dogs%20running%20and%20playing%2C%20owners%20socializing%2C%20fenced%20perimeter%2C%20California%20suburban%20park%2C%20morning%20light&width=600&height=400&seq=park018&orientation=landscape',
    address: '500 Cresta Dr, Roseville, CA 95747',
    hours: 'Sunrise to Sunset',
    amenities: ['Parking', 'Benches', 'Pet Friendly', 'Water Fountain'],
    rating: 4.4,
    reviews: 156,
    featured: false,
    features: ['Open Space', 'Shade Trees', 'Water Stations', 'Waste Stations'],
    coordinates: { lat: 38.7800, lng: -121.3050 }
  }
];

export const naturePreserves = [
  {
    id: 'n1',
    name: 'Sun City Nature Preserve',
    type: 'Nature Preserves',
    description: 'A 40-acre natural open space with native grasslands, vernal pools, and seasonal wetlands. Home to diverse bird species and native wildflower displays in spring.',
    image: 'https://readdy.ai/api/search-image?query=California%20nature%20preserve%20with%20native%20grasslands%2C%20vernal%20pools%2C%20wildflowers%20blooming%2C%20birds%20in%20wetland%20area%2C%20interpretive%20trail%20signs%2C%20natural%20landscape%2C%20conservation%20area%2C%20spring%20season&width=600&height=400&seq=park019&orientation=landscape',
    address: 'Sun City Blvd, Roseville, CA 95747',
    hours: 'Sunrise to Sunset',
    amenities: ['Parking', 'Benches', 'Pet Friendly'],
    rating: 4.3,
    reviews: 89,
    featured: false,
    coordinates: { lat: 38.7900, lng: -121.3200 }
  },
  {
    id: 'n2',
    name: 'Miners Ravine Nature Area',
    type: 'Nature Preserves',
    description: 'A protected riparian corridor along Miners Ravine Creek with interpretive nature trails, wildlife viewing platforms, and educational signage about local ecosystems.',
    image: 'https://readdy.ai/api/search-image?query=Riparian%20nature%20area%20along%20creek%20with%20wildlife%20viewing%20platform%2C%20interpretive%20trail%20signs%2C%20native%20vegetation%2C%20birds%20perched%20on%20branches%2C%20wooden%20boardwalk%20through%20wetland%2C%20California%20nature%20conservation&width=600&height=400&seq=park020&orientation=landscape',
    address: 'Miners Ravine, Roseville, CA 95661',
    hours: 'Sunrise to Sunset',
    amenities: ['Parking', 'Benches', 'ADA Accessible'],
    rating: 4.5,
    reviews: 112,
    featured: false,
    coordinates: { lat: 38.7496, lng: -121.2640 }
  }
];

export const allParksAndFacilities = [
  ...trails,
  ...playgrounds,
  ...sportsFacilities,
  ...dogParks,
  ...naturePreserves
];

export const parkStats = [
  { label: 'Parks & Open Spaces', value: '75+', icon: 'ri-plant-line' },
  { label: 'Miles of Trails', value: '42', icon: 'ri-route-line' },
  { label: 'Sports Facilities', value: '23', icon: 'ri-trophy-line' },
  { label: 'Playgrounds', value: '38', icon: 'ri-gamepad-line' },
  { label: 'Dog Parks', value: '5', icon: 'ri-bear-smile-line' },
  { label: 'Acres of Parkland', value: '3,800', icon: 'ri-landscape-line' }
];

export const trailDifficulties = ['All', 'Easy', 'Moderate', 'Difficult'];
export const trailSurfaces = ['All', 'Paved', 'Dirt/Gravel', 'Mixed'];
